export const RequiredTag = () => (
  <div className="flex h-[2rem] items-center gap-[0.8rem] rounded-[4rem] bg-brand-secondary-light px-[0.8rem] py-[0.4rem]">
    <span className="text-[1.1rem] font-medium leading-[1.6rem]">Required</span>
  </div>
);
